/**
 * BW: restaura los resultados cargados con "Mostrar más" al volver atrás
 * cuando el navegador no aplica bfcache (custom-pagination.js solo cubre el caso bfcache).
 *
 * Guarda el contenido de #filter-results y el scroll en sessionStorage al abandonar
 * la página, y lo reinyecta si se vuelve mediante el botón atrás/adelante.
 */
(() => {
  const MAX_AGE_MS = 30 * 60 * 1000;
  const keyFor = (index) => `bw-pagination:${window.location.pathname}${window.location.search}:${index}`;

  function saveState() {
    document.querySelectorAll('custom-pagination').forEach((el, index) => {
      const results = el.querySelector('#filter-results');
      if (!results) return;
      try {
        sessionStorage.setItem(keyFor(index), JSON.stringify({
          html: results.innerHTML,
          scrollY: window.scrollY,
          count: el.querySelectorAll('.js-pagination-result').length,
          ts: Date.now(),
        }));
      } catch (e) {
        // sessionStorage lleno o no disponible: no se puede restaurar, sin más
      }
    });
  }

  function restoreState() {
    const nav = performance.getEntriesByType('navigation')[0];
    if (!nav || nav.type !== 'back_forward') return;

    let scrollY = null;
    document.querySelectorAll('custom-pagination').forEach((el, index) => {
      const raw = sessionStorage.getItem(keyFor(index));
      if (!raw) return;

      let state;
      try {
        state = JSON.parse(raw);
      } catch (e) {
        return;
      }
      if (Date.now() - state.ts > MAX_AGE_MS) {
        sessionStorage.removeItem(keyFor(index));
        return;
      }

      const results = el.querySelector('#filter-results');
      if (!results) return;

      // Si el bfcache ya restauró el DOM completo, no hacer nada
      if (el.querySelectorAll('.js-pagination-result').length >= state.count) return;

      results.innerHTML = state.html;
      if (typeof el.reload === 'function') el.reload();
      scrollY = state.scrollY;
    });

    if (scrollY !== null) {
      requestAnimationFrame(() => window.scrollTo(0, scrollY));
    }
  }

  window.addEventListener('pagehide', saveState);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreState);
  } else {
    restoreState();
  }
})();
